import { HTTP } from "@/helpers/http-common"

const url = "/api/parametros"

const get = (data) => new Promise((resolve, reject) => {
  const { clave } = data;
  HTTP.get(`${url}/${clave}`
  ).then(response => {
    resolve(response);
  }).catch(error => {
    reject(error);
  });
});

export default { get }



// WEBPACK FOOTER //
// ./src/services/generales/parametros/index.js